<div class="request__step mt-4">
  <h3 class="txt txt--section">1. Nuevo registro de equipo o zona</h3>
  <small class="txt txt--small">Selecciona el campo que quieres ampliar. </small>
  <div class="request__tabs">
    <div class="tabs__head row">
      <div class="col-12 col-lg-4 marginIntoTab">
        <div class="tabs__button js-vehicle" [ngClass]="{'tabs__button--active': selectedOption === 'EQUIPMENT' }"
          (click)="onSelectExtendOption('EQUIPMENT')">
          <h4 class="h4">Equipo</h4>
          <p class="p">Quiero agregar un nuevo equipo a mi licencia.</p>
        </div>
      </div>
      <div class="col-12 col-lg-4  marginIntoTab">
        <div class="tabs__button js-license" [ngClass]="{'tabs__button--active': selectedOption === 'LICENSE_TYPE' }"
          (click)="onSelectExtendOption('LICENSE_TYPE')">
          <h4 class="h4">Tipo de licencia</h4>
          <p class="p">Quiero modificar los registros de conducción y operación de un equipo.</p>
        </div>
      </div>
      <div class="col-12 col-lg-4  marginIntoTab">
        <div class="tabs__button js-zone" [ngClass]="{'tabs__button--active': selectedOption === 'ZONE' }"
          (click)="onSelectExtendOption('ZONE')">
          <h4 class="h4">Zona</h4>
          <p class="p">Quiero ampliar las zonas de un equipo ya registrado.</p>
        </div>
      </div>
    </div>
    <div class="tabs__body tabs__body--vehicle" (click)="onSelectExtendOption('EQUIPMENT')" [ngClass]="{'tabs__body--active': selectedOption === 'EQUIPMENT' }">
      <div class="body__content" [ngClass]="{'tabs__button--active': selectedOption === 'EQUIPMENT' }">
        <div class="body__button"
        >
          <h4>Equipo</h4>
          <p>Quiero agregar un nuevo equipo a mi licencia.</p>
        </div>
      <app-equipment *ngIf="license"
        [selectedOption]= "selectedOption"
        [vehicleTypes]="vehicleTypes"
        [licenseTypes]="licenseTypes"
        [conductionZones]="conductionZones"
        [bannedVehicleTypes]="bannedVehicleTypes"
        [assetName]="license.asset.id === 1 ? 'MEL' : 'SPC'"
        (addEquipment)="onAddEquipment($event)"
      >
      </app-equipment>

    </div>

    </div>
    <div class="tabs__body tabs__body--license" (click)="onSelectExtendOption('LICENSE_TYPE')" [ngClass]="{'tabs__body--active': selectedOption === 'LICENSE_TYPE' }">
      <div class="body__content" [ngClass]="{'body__register--show': selectedOption === 'LICENSE_TYPE'}">
        <div class="body__button">
          <h4>Tipo de licencia</h4>
          <p>Quiero modificar los registros de conducción y operación de un equipo.</p>
      </div>
      <app-extend-form-license
      [selectedOption]="selectedOption"
        [selectedVehicle]="selectedVehicle"
        [vehicleTypes]="vehicleTypes"
        [licenseTypes]="licenseTypes"
        [conductionZones]="conductionZones"
        (addEquipment)="onAddEquipment($event)"
      >
      </app-extend-form-license>
    </div>
    </div>
    <div class="tabs__body tabs__body--zone" [ngClass]="{'tabs__body--active': selectedOption === 'ZONE' }">
      <div class="body__content">
        <div class="body__button" [ngClass]="{'body__button--active': selectedOption === 'ZONE' }"
        (click)="onSelectExtendOption('ZONE')">
          <h4>Zona</h4>
          <p>Quiero ampliar las zonas de un vehículo ya registrado.</p>
      </div>
      <app-zone
        [selectedOption]="selectedOption"
        [selectedVehicle]="selectedVehicle"
        [vehicleTypes]="vehicleTypes"
        [licenseTypes]="licenseTypes"
        [conductionZones]="conductionZones"
        (addEquipment)="onAddEquipment($event)"
      >
      </app-zone>
    </div>

    </div>
    <div class="tabs__body tabs__body--zone responseSelect" [ngClass]="{'tabs__body--active': selectedOption !== 'NONE' }">
      <div class="body__register body__register--border"
        [ngClass]="{'body__register--show': selectedOption !== 'NONE' }">
        <div class="register__head">
          <h4>Nuevos registros</h4>
        </div>
        <div class="table table--register">
          <div class="thead">
            <div class="tr">
              <div class="th">Nº</div>
              <div class="th">Tipo de equipo</div>
              <div class="th">Marca</div>
              <div class="th">Modelo</div>
              <div class="th">Área de conducción</div>
              <div class="th">Tipo de licencia</div>
              <div class="th"></div>
            </div>
          </div>
          <div class="tbody">
            <div class="tr" *ngFor="let item of equipmentsNewToShow; index as i">
              <div class="td td--num">
                <p>{{i + 1}}</p>
              </div>
              <div class="td td--first">
                <p>{{item.typeName}}</p>
              </div>
              <div class="td td--cell">
                <p>{{item.brand}}</p>
              </div>
              <div class="td td--cell">
                <p>{{item.model}}</p>
              </div>
              <div class="td td--cell">
                <p>{{item.conductionZones}}</p>
              </div>
              <div class="td td--cell">
                <p>{{item.licenceTypeNames}}</p>
              </div>
              <div class="td td--cell global-hand displayed" style="padding-left: 0; padding-right: 0;"
                (click)="onRemoveEquipment(i)">
                <img src="assets/img/remove_s.png" alt="X">
              </div>
              <div class="responsiveStyles"  style="position: absolute !important; right: 10px !important;
              top: 5% !important;"
                (click)="onRemoveEquipment(i)">
                <img src="assets/img/remove_s.png" alt="X">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
